import { Subscription } from '../../../../typings/Subscription.interface';

export const isFreePlan = (plan: Subscription['plan']) => {
  return plan.startsWith('free');
};
